import colors from '@/colors';
import { AVATAR_SIZE } from '@/constants/AvatarConstants';
import { classnames } from '@/helpers';
// import * as chroma from 'chroma-js';
// import stc from 'string-to-color';
import { AvatarVariantIcon } from '../AvatarVariantIcon';
import { AvatarProps, AvatarSize } from '../types';

type InitialsAvatarProps = Omit<AvatarProps, 'imgUrl' | 'alt'> & {
  initials: string;
  bgColor?: string;
  textColor?: string;
};

const initialFontSize: Record<AvatarSize, string> = {
  sm: 'text-xxs',
  md: 'text-sm',
  lg: 'text-md',
  xl: 'text-h-m',
};

const InitialsAvatar = ({ initials, variant = 'default', size = 'xl', bgColor, textColor }: InitialsAvatarProps) => {
  const backgroundColor = bgColor ?? colors.primary[700];
  const color = textColor ?? '#FFFFFF';

  return (
    <div className="relative inline-block">
      <div
        style={{ backgroundColor, color }}
        className={classnames(
          AVATAR_SIZE[size],
          'relative flex items-center justify-center overflow-hidden rounded-full',
        )}>
        <span className={classnames(initialFontSize[size])}>{initials || ''}</span>
      </div>
      {variant !== 'default' && <AvatarVariantIcon size={size} variant={variant} />}
    </div>
  );
};

export default InitialsAvatar;
